/* template */
<template><div class="mpx-special-text"><slot name="before"></slot><div v-for="(item, index) in (textArr)" :key="item.index" :data-index="(index)" :style="[((verticalAlign)+(item.style))] | transRpxStyle" class="special-text-item">{{item.text}}</div><slot name="after"></slot></div></template>

/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"m4b847508"}'>
  .mpx-special-text
    display: inline
    & > .special-text-item
      display inline
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4b847508"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex4b847508%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex4b847508%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m4b847508"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index4b847508/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
